<div class="bff-flex-container">
<div class="bff-page-header">
  <div class="bff-page-header__title">
    <h1>
      {{ 'parameters.title' | translate }}
      <span class="bff-badge-container bff-profile-badges bff-profile-badges--inline">
        <span *ngIf="isPremiumDiscoveryUser" class="bff-premium-badge">
          <i class="fas fa-user"></i> PREMIUM DÉCOUVERTE
        </span>
        <span *ngIf="isPremiumGiftedUser && !isPremiumDiscoveryUser" class="bff-premium-badge">
          <i class="fas fa-user"></i> PREMIUM OFFERT
        </span>
        <span *ngIf="isPremiumUser && !isPremiumGiftedUser && !isPremiumDiscoveryUser" class="bff-premium-badge">
          <i class="fas fa-user"></i> PREMIUM
        </span>
        <span *ngIf="isProGiftedUser" class="bff-pro-badge">
          <i class="fas fa-user"></i> PRO OFFERT
        </span>
        <span *ngIf="isProUser && !isProGiftedUser" class="bff-pro-badge">
          <i class="fas fa-user"></i> PRO
        </span>
        <span *ngIf="isEssentielGiftedUser" class="bff-essentiel-badge">
          <i class="fas fa-user"></i> ESSENTIEL OFFERT
        </span>
        <span *ngIf="isEssentielUser && !isEssentielGiftedUser" class="bff-essentiel-badge">
          <i class="fas fa-user"></i> ESSENTIEL
        </span>
        <span *ngIf="isStandardAutoImportUser" class="bff-standard-badge">
          <i class="fas fa-user"></i> STANDARD AUTO-IMPORT
        </span>
        <span *ngIf="isStandardUser && !isStandardAutoImportUser && !isEssentielUser && !isProUser && !isPremiumUser" class="bff-standard-badge">
          <i class="fas fa-user"></i> STANDARD
        </span>
      </span>
    </h1>
  </div>
</div>


<div class="parameters-container">
  
  <ul class="parameters-list">
    <li *ngFor="let link of parameterLinks" class="parameter-item">
      <div class="parameter-card">
      <a [routerLink]="[link.path]" class="parameter-link">
        <i class="bi" [ngClass]="link.icon"></i>
        <span class="parameter-text">{{ link.name }}</span>
      </a>
      <p class="parameter-description">{{ link.description }}</p>
      </div>
    </li>
  </ul>
</div>

</div>
